<template>
  <div class="publicvenue-list">
    <el-table
      ref="multipleTable"
      :data="publicvenueList"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="venueName"
        label="场馆名字"
        width="250px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        width="200px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="medal"
        label="场馆状态"
        width="100px"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          {{ scope.row.status == "0" ? "正常" : "停用" }}
        </template>
      </el-table-column>
      <el-table-column prop="venueRemark" label="备注" :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="操作" width="185px">
        <template slot-scope="scope">
          <div class="handle-container">
            <!-- 修改 -->
            <el-button
              type="warning"
              icon="el-icon-edit"
              @click="editClick(scope.row)"
              v-hasPermi="'sc:publicvenue:edit'"
              size="small"
            >修改
            </el-button>
            <!-- 详情 -->
            <!-- <el-button
              type="success"
              icon="el-icon-info"
              @click="detailClick(scope.row)"
            >
            </el-button> -->
            <!-- 删除 -->
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="deleteClick(scope.row)"
              v-hasPermi="'sc:publicvenue:delete'"
              size="small"
            >删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 详情 -->
    <!-- <publicvenueDetail
      :publicvenueDetail="publicvenueDetail"
      :detailShow.sync="detailShow"
      v-if="detailShow"
    /> -->
    <!-- 修改场馆信息 -->
    <publicvenueEdit
      v-show="editShow"
      :dialogFormVisible.sync="editShow"
      :publicvenueData="publicvenueData"
    />
  </div>
</template>

<script>
// import publicvenueDetail from "../publicvenue-detail/publicvenueDetail.vue";
import publicvenueEdit from "../publicvenue-edit/publicvenueEdit";
export default {
  components: {
    // publicvenueDetail,
    publicvenueEdit,
  },
  data() {
    return {
      title: "",
      publicvenueData: {},
      detailShow: false,
      editShow: false,
    };
  },
  inject: ["refresh"],
  props: {
    publicvenueList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.id);
      });
      this.$emit("multipleDelete", list);
    },
    // detailClick(item) {
    //   this.get(this.$url.getPublicvenueDetail + "/" + item.id).then((res) => {
    //     // console.log("场馆详情==>", res);
    //     this.publicvenueDetail = res.data;
    //     this.detailShow = true;
    //   });
    // },
    // 点击编辑
    editClick(item) {
      // console.log(item);
      this.publicvenueData = item;
      this.editShow = true;
    },
    // 点击删除
    deleteClick(item) {
      // console.log(item);
      this.$confirm("是否删除该场馆?", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass: "confirm",
      })
        .then(() => {
          // 调用删除学生信息接口
          let list = [];
          list.push(item.id);
          this.delete(this.$url.delPublicvenue + "/" + list)
            .then((res) => {
              // console.log(res);
              if (res.code == 200) {
                this.$message.success("删除成功");
                // 刷新列表
                this.refresh();
              }
            })
            .catch((err) => {
              // console.log(err);
              this.$message.error("删除失败，请稍后重试");
            });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./publicvenueList.scss";
</style>
